import { render, staticRenderFns } from "./ShowPrintVersion.vue?vue&type=template&id=40bb0da6&scoped=true&"
import script from "./ShowPrintVersion.vue?vue&type=script&lang=js&"
export * from "./ShowPrintVersion.vue?vue&type=script&lang=js&"
import style0 from "./ShowPrintVersion.vue?vue&type=style&index=0&id=40bb0da6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb0da6",
  null
  
)

export default component.exports